var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5149 18.3001C12.1938 18.3001 13.8171 17.6868 15.0858 16.5731L15.8224 15.9265L16.3585 15.1025C17.115 13.9396 17.5149 12.5837 17.5149 11.1813C17.5149 7.25598 14.3747 4.0625 10.5149 4.0625C6.65508 4.0625 3.51489 7.25598 3.51489 11.1813C3.51489 15.1066 6.65508 18.3001 10.5149 18.3001ZM21.2483 21.9354C20.961 21.9354 20.6724 21.8344 20.4383 21.6285L16.4052 18.0761C14.8267 19.4618 12.7675 20.3001 10.5149 20.3001C5.54419 20.3001 1.51489 16.2177 1.51489 11.1813C1.51489 6.1449 5.54419 2.0625 10.5149 2.0625C15.4856 2.0625 19.5149 6.1449 19.5149 11.1813C19.5149 13.0328 18.9706 14.7549 18.0349 16.1931L22.0601 19.7385C22.5749 20.1921 22.6298 20.9823 22.1816 21.5043C21.9374 21.7893 21.5938 21.9354 21.2483 21.9354Z",
    fill: "#4FB1EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZoom);
export default __webpack_public_path__ + "static/media/IconZoom.361ed597.svg";
export { ForwardRef as ReactComponent };